import React from 'react';
import { Separator } from "@/components/ui/separator";
import { Instagram, Users } from "lucide-react";
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-10 md:pt-12 pb-24 md:pb-8 px-4 md:px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          <div>
            <img 
              src="/lovable-uploads/8cb82dc5-bab6-4fd8-bab0-219185db8742.png" 
              alt="Logo TaxHealth"
              className="h-8 md:h-10 w-auto mb-4"
              width={40}
              height={40}
              loading="lazy"
            />
            <p className="text-sm md:text-base text-gray-300 mb-4 md:mb-6">
              Soluções fiscais inovadoras para profissionais da saúde. A TaxHealth realiza todo o serviço tributário de ponta a ponta.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/taxhealthbr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-pink-400 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" aria-hidden="true" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-white text-lg md:text-xl font-semibold mb-3 md:mb-4">Links Rápidos</h3>
            <ul className="space-y-2 text-sm md:text-base">
              <li className="min-h-[44px] flex items-center"><Link to="/sobre-a-taxhealth" className="text-gray-300 hover:text-white transition-colors py-2">Sobre a Tax Health</Link></li>
              <li className="min-h-[44px] flex items-center"><Link to="/o-que-fazemos" className="text-gray-300 hover:text-white transition-colors py-2">O que Fazemos</Link></li>
              <li className="min-h-[44px] flex items-center"><Link to="/equiparacao-hospitalar" className="text-gray-300 hover:text-white transition-colors py-2">Equiparação Hospitalar</Link></li>
              <li className="min-h-[44px] flex items-center"><Link to="/contabilidade" className="text-gray-300 hover:text-white transition-colors py-2">Contabilidade</Link></li>
              <li className="min-h-[44px] flex items-center"><Link to="/nossos-clientes" className="text-gray-300 hover:text-white transition-colors py-2">Nossos Clientes</Link></li>
              <li className="min-h-[44px] flex items-center"><Link to="/calcule-sua-restituicao" className="text-gray-300 hover:text-white transition-colors py-2">Calcule sua Restituição</Link></li>
              <li className="min-h-[44px] flex items-center"><Link to="/descubra-sua-economia-com-a-taxhealth" className="text-gray-300 hover:text-white transition-colors py-2">Descubra sua Economia</Link></li>
              <li className="min-h-[44px] flex items-center"><Link to="/blog" className="text-gray-300 hover:text-white transition-colors py-2">Blog</Link></li>
              <li className="min-h-[44px] flex items-center">
                <Link to="/login" className="text-gray-300 hover:text-white transition-colors py-2 flex items-center gap-1">
                  <Users className="h-3.5 w-3.5" />
                  Acesso Representantes
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <Separator className="my-6 md:my-8 bg-gray-700" />
        
        <div className="space-y-4 text-xs md:text-sm text-gray-300">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-0">
            <div className="text-center md:text-left">
              © 2023 Tax Health - All Rights Reserved
            </div>
            <div className="flex items-center gap-4 text-center md:text-right">
              <button
                type="button"
                onClick={() => {
                  import('@/utils/consent').then(({ resetConsent }) => resetConsent());
                }}
                className="text-gray-300 hover:text-white transition-colors underline-offset-2 hover:underline"
              >
                Gerenciar cookies
              </button>
              <span>Processos 100% administrativos, sem ação judicial</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
